var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.16602 12.5H6.66602C5.11288 12.5 4.33631 12.5 3.72374 12.7537C2.90698 13.092 2.25806 13.741 1.91975 14.5577C1.66602 15.1703 1.66602 15.9469 1.66602 17.5M12.916 2.7423C14.1376 3.23679 14.9993 4.43443 14.9993 5.83333M9.99924 17.9167L11.6868 17.5792C11.834 17.5497 11.9075 17.535 11.9761 17.5081C12.037 17.4842 12.0949 17.4533 12.1485 17.4159C12.209 17.3737 12.262 17.3206 12.3681 17.2145L17.9161 11.6667C18.3763 11.2065 18.3763 10.4602 17.916 9.99998C17.4558 9.53975 16.7096 9.53976 16.2494 10L10.7014 15.5479C10.5954 15.654 10.5423 15.707 10.5002 15.7675C10.4627 15.8211 10.4318 15.879 10.4079 15.9399C10.381 16.0085 10.3663 16.082 10.3368 16.2292L9.99924 17.9167ZM11.2493 5.83333C11.2493 7.67428 9.75697 9.16667 7.91602 9.16667C6.07507 9.16667 4.58268 7.67428 4.58268 5.83333C4.58268 3.99238 6.07507 2.5 7.91602 2.5C9.75697 2.5 11.2493 3.99238 11.2493 5.83333Z",
    stroke: "#424242",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersEdit);
export default __webpack_public_path__ + "static/media/usersEdit.a7bbc78e27cde2103927e86b3492301e.svg";
export { ForwardRef as ReactComponent };